import { defineModule } from '@/app/router/defineModule.ts';
import redirectIfAuthenticated from '@/app/router/middleware/redirectIfAuthenticated.js';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';

export default defineModule({
    name: 'auth',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('#modules/auth/pages/login.vue'),
            meta: {
                layout: 'auth',
                middleware: [redirectIfAuthenticated],
            },
        },
        {
            path: '/admin',
            redirect: '/admin/login',
        },
        {
            path: '/admin/login',
            name: 'admin login',
            component: () => import('#modules/auth/pages/admin-login.vue'),
            meta: {
                layout: 'auth',
                middleware: [redirectIfAuthenticated],
            },
        },
        {
            path: '/logout',
            name: 'logout',
            component: () => import('#modules/auth/pages/logout.vue'),
            meta: {
                layout: null,
                transition: 'fade',
                middleware: [shouldBeAuthenticated],
            },
        },
        {
            path: '/password-forgot',
            name: 'password forgot',
            component: () => import('#modules/auth/pages/password-forgot.vue'),
            meta: {
                layout: 'auth',
                middleware: [redirectIfAuthenticated],
            },
        },
        {
            path: '/password/reset/:token',
            name: 'password reset',
            component: () => import('#modules/auth/pages/password-reset.vue'),
            meta: {
                layout: 'auth',
                middleware: [redirectIfAuthenticated],
            },
        },
        {
            path: '/sign-up',
            name: 'sign up',
            component: () => import('#modules/auth/pages/sign-up.vue'),
            meta: {
                layout: 'auth',
                middleware: [redirectIfAuthenticated],
            },
        },
        {
            path: '/email/confirm/:token',
            name: 'confirm email',
            component: () => import('#modules/auth/pages/confirm-email.vue'),
            meta: {
                layout: 'auth',
            },
        },
        {
            path: '/registration/complete',
            name: 'complete registration',
            component: () => import('#modules/auth/pages/complete-registration.vue'),
            meta: {
                layout: 'public',
                middleware: [shouldBeAuthenticated],
            },
        },
        {
            path: '/user/confirm/:token',
            name: 'confirm account',
            component: () => import('#modules/auth/pages/confirm-account.vue'),
            meta: {
                layout: 'auth',
                middleware: [redirectIfAuthenticated],
            },
        },
        {
            path: '/tfa-setup',
            name: 'tfa setup',
            component: () => import('#modules/auth/pages/two-factor-setup.vue'),
            meta: {
                layout: 'auth',
                middleware: [shouldBeAuthenticated],
            },
        },
    ],
});
